<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditRoomForm" :rules="addEditRoomRules" ref="addEditRoomForm" label-width="130px" class="demo-ruleForm">
    <el-row>
      <el-col :span="24">
        <el-form-item label="所属楼栋/楼层" prop="orgid">
          <el-cascader v-fixZoom style="width: 100%" :options="orgOptions"
                       v-model="addEditRoomForm.orgid" :filterable="true" placeholder="请选择楼栋/楼层"
                       :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                       ref="orgOptions" @change="changeNodes">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="房间号" prop="room">
          <el-input v-model="addEditRoomForm.room" placeholder="请输入房间号"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否有卫生间" prop="isHaveToilet">
          <el-radio-group v-model="addEditRoomForm.isHaveToilet">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="房间类型" prop="roomType">
          <el-select v-fixZoom v-model="addEditRoomForm.roomType" filterable placeholder="请选择" :clearable="false" style="width:100%;" @change="chengRoomType">
            <el-option v-for="item in roomTypes" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="床位数" prop="bednums">
          <el-input disabled type="number" v-model="addEditRoomForm.bednums" placeholder="请输入床位数"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="是否安装电视" prop="isHaveTV">
          <el-radio-group v-model="addEditRoomForm.isHaveTV">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="电视安装时间" prop="">
          <el-date-picker v-fixZoom style="width:100%;" v-model="addEditRoomForm.tvDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="床位月价格(元)" prop="">
          <el-input type="number" v-model="addEditRoomForm.bedPrice" placeholder="请输入床位月价格"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="包房月价格(元)" prop="">
          <el-input type="number" v-model="addEditRoomForm.bedMonthPrice" placeholder="请输入包房月价格"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
<!--      <el-col :span="12">-->
<!--        <el-form-item label="是否有卫生间" prop="isHaveToilet">-->
<!--          <el-radio-group v-model="addEditRoomForm.isHaveToilet">-->
<!--            <el-radio :label="1">是</el-radio>-->
<!--            <el-radio :label="0">否</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
      <el-col :span="24">
        <el-form-item label="房间描述" prop="">
          <el-input type="textarea" :rows="2" placeholder="请输入房间描述"  v-model="addEditRoomForm.description"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditRoom('addEditRoomForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {addorghome, updateorghome} from '../../../api/relation'

export default {
  name: 'addEditRoom',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    roomRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgArr: [],
      orgOptions: [],
      oldRoomType: '', // 旧房间类型
      addEditRoomForm: {
        id: 0,
        telephone: '',
        address: '',
        lng: 0,
        lat: 0,
        cid: -1,
        building: '',
        unit: '',

        room: '',
        isbednumchanged: 0,
        orgid: '',
        extra_info: {},
        bednums: '',
        isHaveTV: '',
        // 自定义
        isHaveToilet: '',
        roomType: '',
        tvDate: '',
        bedPrice: '',
        bedMonthPrice: '',
        description: ''
      },
      addEditRoomRules: {
        room: [{ required: true, message: '请输入房间号', trigger: 'blur' }],
        bednums: [{ required: true, message: '请输入床位数', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择楼栋/楼层', trigger: 'change' }],
        isHaveTV: [{ required: true, message: '请选择', trigger: 'change' }],
        isHaveToilet: [{ required: true, message: '请选择', trigger: 'change' }],
        roomType: [{ required: true, message: '请选择房间类型', trigger: 'change' }],
        tvDate: [{ required: true, message: '请选择电视安装时间', trigger: 'change' }]
      },
      roomTypes: [
        {id: 0, name: '单人间'},
        {id: 1, name: '双人间'},
        {id: 2, name: '三人间'},
        {id: 3, name: '四人间'},
        {id: 4, name: '五人间'},
        {id: 5, name: '六人间'}
      ],
      build: []
    }
  },
  created () {
    this.orgArr = this.roomRow.orgArr
    this.orgOptions = this.roomRow.treeData
    // console.log(this.roomRow.row)
    if (!this.roomRow.isAdd) {
      this.addEditRoomForm.id = this.roomRow.row.id
      this.addEditRoomForm.telephone = this.roomRow.row.telephone
      this.addEditRoomForm.address = this.roomRow.row.address
      this.addEditRoomForm.lng = this.roomRow.row.lng
      this.addEditRoomForm.lat = this.roomRow.row.lat
      this.addEditRoomForm.cid = this.roomRow.row.cid
      this.addEditRoomForm.building = this.roomRow.row.building
      this.addEditRoomForm.unit = this.roomRow.row.unit
      this.addEditRoomForm.room = this.roomRow.row.room
      this.addEditRoomForm.orgid = this.roomRow.row.orgid
      if (this.roomRow.row.extra_info !== null) {
        let info = this.roomRow.row.extra_info
        this.addEditRoomForm.bednums = info.bednums
        this.addEditRoomForm.isHaveTV = info.isHaveTV
        // 自定义
        this.addEditRoomForm.isHaveToilet = info.isHaveToilet
        this.addEditRoomForm.roomType = info.roomType
        this.oldRoomType = this.clone(this.addEditRoomForm.roomType)
        this.addEditRoomForm.tvDate = info.tvDate
        this.addEditRoomForm.bedPrice = info.bedPrice
        this.addEditRoomForm.bedMonthPrice = info.bedMonthPrice
        this.addEditRoomForm.description = info.description
        this.addEditRoomForm.isbednumchanged = info.isbednumchanged ? info.isbednumchanged : 0
      }
    }
  },
  methods: {
    chengRoomType (id) {
      this.addEditRoomForm.bednums = parseInt(id) + 1
    },
    changeNodes (id) {
      let obj = ''
      this.orgArr.forEach(item => {
        if (item.id === id) {
          obj = item
        }
      })
      if (obj !== '') {
        let orgpid = obj.orgpid
        this.addEditRoomForm.unit = obj.name
        this.addEditRoomForm.building = ''
        for (let i = 0; i < this.orgArr.length; i++) {
          if (orgpid === this.orgArr[i].id) {
            this.addEditRoomForm.building = this.orgArr[i].name
          }
        }
      }
      console.log(this.addEditRoomForm.unit, this.addEditRoomForm.building)
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEditRoom (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let info = {
            bednums: this.addEditRoomForm.bednums + '',
            isHaveTV: this.addEditRoomForm.isHaveTV,
            // 自定义
            isHaveToilet: this.addEditRoomForm.isHaveToilet,
            roomType: this.addEditRoomForm.roomType,
            tvDate: this.addEditRoomForm.tvDate,
            bedPrice: this.addEditRoomForm.bedPrice + '',
            bedMonthPrice: this.addEditRoomForm.bedMonthPrice + '',
            description: this.addEditRoomForm.description
          }
          let data = {
            id: this.addEditRoomForm.id,
            telephone: this.addEditRoomForm.telephone,
            address: this.addEditRoomForm.address,
            lng: parseFloat(this.addEditRoomForm.lng),
            lat: parseFloat(this.addEditRoomForm.lat),
            cid: this.addEditRoomForm.cid,
            building: this.addEditRoomForm.building,
            unit: this.addEditRoomForm.unit,

            room: this.addEditRoomForm.room,
            isbednumchanged: this.addEditRoomForm.isbednumchanged + '',
            orgid: this.addEditRoomForm.orgid,
            extra_info: JSON.stringify(info)
          }
          if (!this.roomRow.isAdd) {
            if (this.addEditRoomForm.roomType !== this.oldRoomType) {
              data.isbednumchanged = '1'
            }
          }
          if (this.roomRow.isAdd) {
            addorghome(data).then(res => {
              this.$notify({title: '成功', message: '成功新增房间', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            updateorghome(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑房间', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditRoom.vue